/**
 * api/assignment.js — ЗӨРЧЛИЙН ДААЛГАВАР (хариуцагчийн тал).
 *
 * Backend: Resources/XAB/my_assignment.py
 *
 * ⚠ Урсгал ХОЁР ТАЛТ:
 *     open → (хариуцагч илгээв) submitted → (шалгагч хүлээн авав) closed
 *   Хариуцагч ӨӨРӨӨ хаах эрхгүй — эс бөгөөс шалгалт нь өөрийгөө шалгасан
 *   хэлбэр болно.
 *
 * ⚠ `API()`-г ашиглав — `src/api/help.js`-тэй ижил загвар. Токен,
 *   үндсэн хаягийг тэр нэг дор барьдаг тул энд давтахгүй.
 */
import { API } from "src/api/request";

/** Надад хувиарлагдсан даалгаврууд + хураангуй. */
export async function fetchMyAssignments(params) {
  const res = await API().get("/xab/my-assignments", { params });
  return res.data;
}

/** Хариуцагч биелэлтээ илгээнэ: { note, photo_url } */
export async function submitAssignmentFix(itemId, payload) {
  const res = await API().post(`/xab/inspection-items/${itemId}/fix`, payload);
  return res.data;
}

/** Шалгагч хүлээн авна / буцаана: { action: "accept"|"reject", note } */
export async function verifyAssignment(itemId, payload) {
  const res = await API().post(
    `/xab/inspection-items/${itemId}/verify`,
    payload,
  );
  return res.data;
}
